var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-xl":"","text-center":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('v-alert',{attrs:{"type":"error"}},[_vm._v("\n        ページがありません。\n      ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }